
import React from 'react';
import classes from './CampfireAnimation.module.css';



const CampfireAnimation = () => {

  return (
    <div className={classes.stage}>
      <div className={classes.campfire}>
        <div className={classes.sparks}>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
          <div className={classes.spark}></div>
        </div>
        <div className={classes.logs}>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
          <div className={classes.log}>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
            <div className={classes.streak}></div>
          </div>
        </div>
        <div className={classes.sticks}>
          <div className={classes.stick}></div>
          <div className={classes.stick}></div>
          <div className={classes.stick}></div>
          <div className={classes.stick}></div>
        </div>
        <div className={classes.fire}>
          <div className={classes.fire__red}>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
          </div>
          <div className={classes.fire__orange}>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
          </div>
          <div className={classes.fire__yellow}>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
          </div>
          <div className={classes.fire__white}>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
            <div className={classes.flame}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CampfireAnimation;